<template   @load="$emit('loaded-video')">
  <div class="media-player-container" :id="'video-player-' + this.slideID">
    <video
      ref="mediaPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
      playsinline
    ></video>
    <PlayButton class="play-btn" />
    <div
      class="bigPlayButtonContainer"
      :id="'bigPlayButtonContainer-' + this.slideID"
    >
      <div
        class="play-btn"
        :id="'bigPlayButtonMountRoot-' + this.slideID"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import videojs from "video.js";
import jQuery from "jquery";
import { isIOSdevice } from "../../../../../src/helpers/validators.js";
import PlayButton from "./play-button.vue";
import {
  buildThumbURL,
  buildAttachmentURL,
  buildAttachmentHLSpath,
} from "../../../../helpers/assets";
import { convertMilliSecondsToIsoFormat } from "../../../../helpers/formatters.js";
import { mapState } from "vuex";
import ReRenderer from "../../mixins/re-renderer.vue";

export default {
  mixins: [ReRenderer],
  components: {
    PlayButton: PlayButton,
  },
  name: "MediaPlayer",
  props: [
    "slideID",
    "postID",
    "attachmentID",
    "extension",
    "hash",
    "hls_path",
    "thumbExtension",
    "thumbHash",
    "continue_video",
    "activeVideoIndex",
  ],
  data() {
    return {
      isPlaying: false,
      player: null,
      isFirstLoad: true,
      reached_popup_time: false,
      reRenderCssSelectors: [
        {
          jquerySelectors: ".vjs-control-bar",
          properties: [
            {
              propertyName: "top",
              propertyValue: this.getSeekbarHeightFromTop,
              isCallBack: true,
            },
          ],
        },
        {
          jquerySelectors: ".media-player-container",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
        {
          jquerySelectors: ".video-js",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
      ],
    };
  },
  watch: {
    video_to_resume_now(newVideoIndex, oldVideoIndex) {
      console.log("watch resume video ", newVideoIndex, oldVideoIndex);
      if (this.slideID == newVideoIndex) {
        this.player.currentTime(0);
        this.player.play();
        this.reached_popup_time = false;
        this.$store.dispatch("shares/clear_VideToResumeNow_Action");
      }
    },
    activeVideoIndex: function (newActiveSlideIndex) {
      if (this.slideID == newActiveSlideIndex) {
        this.player.play();
        // We will hide the play button here because HTML5 "play" event deplays sometimes
        this.hidePlayButton();
        // Sometimes the video doesnt play on ios so we will show the play button
        if (this.player.paused()) this.showPlayButton();
      } else {
        this.player.pause();
      }
    },
    continue_video: function (value) {
      if (value) {
        this.player.play();
      } else {
        this.player.pause();
      }
    },
  },
  methods: {
    getSeekbarHeightFromTop() {
      return jQuery(".seek-bar").offset().top + "px";
    },
    hideBigPlaybutton() {
      jQuery(".vjs-big-play-button").css("display", "none");

      // Show seekbar
      jQuery(".vjs-control-bar").css("top", this.getSeekbarHeightFromTop());
    },
    handleMediaSessionState() {
      //https://developer.mozilla.org/en-US/docs/Web/API/Media_Session_API UHV-17665
      navigator.mediaSession.setActionHandler("play", () => {
        this.hidePlayButton();
        this.player.play();
      });
      navigator.mediaSession.setActionHandler("pause", () => {
        this.showPlayButton();
        this.player.pause();
      });
      navigator.mediaSession.setActionHandler("stop", () => {
        this.showPlayButton();
        this.player.currentTime(0);
        this.player.pause();
      });
    },
    showPlayButton() {
      jQuery(".play-btn").css("display", "inline");
    },
    hidePlayButton() {
      jQuery(".play-btn").css("display", "none");
    },
    updateSeekTime() {
      var video_duration = this.player.duration();
      var current_time = this.player.currentTime();

      jQuery(".vjs-remaining-time").html(
        convertMilliSecondsToIsoFormat(current_time) +
          " / " +
          convertMilliSecondsToIsoFormat(video_duration)
      );
    },
    showPopup() {
      if (!this.reached_popup_time & (this.player.currentTime() > 600)) {
        this.$emit("showVideoPopup_event");
        this.reached_popup_time = true;
        this.player.pause();
        this.$store.dispatch(
          "shares/setVideoPauseFromPopUp_Action",
          this.slideID
        );
      }
    },
    loopShortVideo() {
      this.player.currentTime(0);
      this.player.play();
      console.log("Video ended ");
    },
    playerClicked(e) {
      let target = e?.target;
      let volClasses = target?.classList;
      if (!this.isPlaying) {
        this.player.play();
        this.hidePlayButton();

        if (this.isFirstLoad){
          this.$emit("is_media_clicked", {'is_media_played': true});
          this.isFirstLoad = false;
        }
        if (!this.isFirstLoad && volClasses && !volClasses.contains('vjs-volume-control') && !volClasses.contains('vjs-icon-placeholder') && !volClasses.contains('vjs-volume-panel-horizontal') && !volClasses.contains('vjs-volume-panel')){
          this.$emit("is_media_clicked", {'is_media_played': true});
        }
      } else {
        if (!this.isFirstLoad && volClasses && !volClasses.contains('vjs-volume-control') && !volClasses.contains('vjs-icon-placeholder')  && !volClasses.contains('vjs-volume-panel-horizontal') && !volClasses.contains('vjs-volume-panel')){ // Don't show/hide controlls if mute btn is clicked
          this.player.pause();
          this.showPlayButton();
          this.$emit("is_media_clicked", {'is_media_played': false});
        }
      }
    },
  },
  computed: {
    mediaThumb() {
      return buildThumbURL(
        this.postID,
        this.attachmentID,
        this.thumbExtension,
        this.thumbHash
      );
    },
    mediaPath() {
      return buildAttachmentURL(
        this.postID,
        this.attachmentID,
        this.extension,
        this.hash
      );
    },
    mediaPathHLS() {
      // in ios devices HLS doesnt work so we will return the MP4 instead of HLS
      // #TODO fix the problem later
      if (isIOSdevice() || this.hls_path == null)
        return buildAttachmentURL(
          this.postID,
          this.attachmentID,
          this.extension,
          this.hash
        );
      else
        return buildAttachmentHLSpath(
          this.postID,
          this.attachmentID,
          this.extension,
          this.hash,
          this.hls_path
        );
    },
    ...mapState("shares", ["video_to_resume_now"]),
  },
  mounted() {
    this.$emit("loaded-video");
    let options = {
      poster: this.mediaThumb,
      controls: true,
      muted: true,
      bigPlayButton: true,
      controlBar: {
        pictureInPictureToggle: false,
        playToggle: false,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: true,
        progressControl: {
          seekBar: true,
        },
        fullscreenToggle: false,
        playbackRateMenuButton: false,
      },
      headers: {
        hpath: this.hls_path,
      },
      sources: [
        {
          withCredentials: false,
          src: this.mediaPathHLS,
        },
        {
          withCredentials: false,
          src: this.mediaPath,
          type: "video/mp4",
        },
      ],
    };
    this.player = videojs(this.$refs.mediaPlayer, options, () => {
      this.player.on("timeupdate", () => this.showPopup());
      this.player.on("timeupdate", () => this.updateSeekTime());
      this.player.on("ended", () => this.loopShortVideo());
      this.player.on("play", () => this.hideBigPlaybutton());
      // this.player.on("pause", () => this.showPlayButton());
      this.player.on("click", (e) => this.playerClicked(e));
      this.player.on("touchstart", (e) => this.playerClicked(e)); // #FIXME fix this to only stop/pause on TAP not on touch
      this.player.playsinline(true);

      this.player.on(["waiting", "pause"], () => {
        this.isPlaying = false;
      });

      this.player.on("playing", () => {
        this.isPlaying = true;
      });

      // this.player.fluid(true);
      // this.player.aspectRatio('3:4');
    });
    jQuery(document).ready(function () {
      jQuery(".video-js").css("height", jQuery(window).height() + "px");
    });
    this.handleMediaSessionState();

    // Instantiate and inject the play button into the player
    if (
      jQuery("#video-player-" + this.slideID).find(".vjs-big-play-button")
        .length
    ) {
      jQuery("#video-player-" + this.slideID)
        .find(".vjs-big-play-button")
        .append(jQuery("#bigPlayButtonContainer-" + this.slideID));
      let playButton = Vue.extend(PlayButton);
      new playButton().$mount("#bigPlayButtonMountRoot-" + this.slideID);
      let thisPlayer = this;
      setTimeout(function(){
        thisPlayer.playerClicked()
      }, 500);
    }


  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style>
body{
  background-color: #000;
}
.video-js .vjs-volume-menu-button {
  display: none;
}
.vjs-fade-in,
.vjs-fade-out,
.vjs-control-bar {
  visibility: visible !important;
  opacity: 1 !important;
  transition-duration: 0s !important;
}

.video-js .vjs-big-play-button {
  background-color: transparent !important;
  border: none !important;
}
.vjs-icon-placeholder {
  display: none;
}
.video-js .vjs-control-bar{
  width: 100% !important;
}
.vjs-control-bar {
  /* height:4.5vh !important; */
  position: absolute;
  background-color: transparent !important;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  justify-content: center;
  align-items: center;

  /* display: none !important; */
}
.video-js .vjs-play-progress:before {
  background-color: #2979ff !important;
  border-radius: 0.5rem !important;
  border: 1px solid #2979ff;
}
</style> 

<style scoped>
.video-js {
  width: 100%;
  /* height:100px; */
}

.play-btn {
  display: none;
  position: absolute;
  margin: 0;
  padding: 0;
  width: 5rem;
  pointer-events: none;
}
.media-player-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bigPlayButtonContainer {
  position: relative;
}
</style>
